import { authHeader, BASE_URL, handleResponse } from '@helpers/api';
import { ProductEvent } from '@constants/product-events';
import { captureOnSuccess } from '@helpers/product-events';

export const facebookIntegrationService = {
    disconnectIntegration,
    authenticateFacebookIntegration,
    getPages,
    editProfile,
    getLocationListing,
    updateLocationListing,
    authenticateMetaBusinessIntegration,
};

function getPages(integrationId = null) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    const query = integrationId ? `?integrationId=${integrationId}` : '';
    return fetch(`${BASE_URL}api/facebook/pages${query}`, requestOptions).then(handleResponse);
}

function disconnectIntegration(integrationId) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
    };

    const query = integrationId ? `?integrationId=${integrationId}` : '';
    return fetch(`${BASE_URL}api/facebook/disconnect-integration${query}`, requestOptions).then(handleResponse);
}

function authenticateFacebookIntegration(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/facebook/connect-integration`, requestOptions)
        .then(handleResponse)
        .then(captureOnSuccess(ProductEvent.IntegrationConnected, { integration: 'facebook' }));
}

function authenticateMetaBusinessIntegration(data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/facebook/authenticate-system-user`, requestOptions).then(handleResponse);
}

function editProfile(locationId, data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/facebook:connect`, requestOptions).then(
        handleResponse,
    );
}

function getLocationListing(locationId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader(),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/facebook/listing`, requestOptions).then(
        handleResponse,
    );
}

function updateLocationListing(locationId, data) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader(),
        body: JSON.stringify(data),
    };

    return fetch(`${BASE_URL}api/locations/${locationId}/integrations/facebook/listing`, requestOptions).then(
        handleResponse,
    );
}
